/* global t */
// Help articles for sales registers (customers, products, agreements, daily settlement,
// projects, inventory). Merged into helpArticles() in help-articles.jsx.
// Screenshots use the PlummeDEMO business so no customer data is exposed.
window.PlummeHelpArticlePacks = (window.PlummeHelpArticlePacks || []).concat([() => ({
  customers: { id: 'customers', title: t('ha.customers.title'), category: t('ha.cat.sales'), read: t('ha.read2'), route: 'kunder',
    keywords: t('ha.customers.keywords'),
    lead: t('ha.customers.lead'),
    blocks: [
    { t: 'step', n: 1, title: t('ha.customers.add'), text: t('ha.customers.addText') },
    { t: 'figure', src: 'src/img/help/customers-new.png', caption: t('ha.customers.add') },
    { t: 'tip', kind: 'info', title: t('ha.customers.private'), text: t('ha.customers.privateText') },
    { t: 'step', n: 2, title: t('ha.customers.follow'), text: t('ha.customers.followText') },
    { t: 'step', n: 3, title: t('ha.customers.invoice'), text: t('ha.customers.invoiceText') },
    { t: 'tip', kind: 'tip', title: t('ha.customers.import'), text: t('ha.customers.importText') }]
  },
  products: { id: 'products', title: t('ha.products.title'), category: t('ha.cat.sales'), read: t('ha.read2'), route: 'produkter',
    keywords: t('ha.products.keywords'),
    lead: t('ha.products.lead'),
    blocks: [
    { t: 'step', n: 1, title: t('ha.products.add'), text: t('ha.products.addText') },
    { t: 'figure', src: 'src/img/help/products-new.png', caption: t('ha.products.add') },
    { t: 'step', n: 2, title: t('ha.products.type'), text: t('ha.products.typeText') },
    { t: 'step', n: 3, title: t('ha.products.account'), text: t('ha.products.accountText') },
    { t: 'step', n: 4, title: t('ha.products.use'), text: t('ha.products.useText') },
    { t: 'tip', kind: 'tip', title: t('ha.customers.import'), text: t('ha.products.importText') }]
  },
  agreements: { id: 'agreements', title: t('ha.agreements.title'), category: t('ha.cat.sales'), read: t('ha.read3'), route: 'abonnement',
    keywords: t('ha.agreements.keywords'),
    lead: t('ha.agreements.lead'),
    blocks: [
    { t: 'heading', text: t('ha.agreements.subs') },
    { t: 'step', n: 1, title: t('ha.agreements.create'), text: t('ha.agreements.createText') },
    { t: 'figure', src: 'src/img/help/agreements-new.png', caption: t('ha.agreements.create') },
    { t: 'step', n: 2, title: t('ha.agreements.customers'), text: t('ha.agreements.customersText') },
    { t: 'step', n: 3, title: t('ha.agreements.manage'), text: t('ha.agreements.manageText') },
    { t: 'heading', text: t('ha.agreements.recurring') },
    { t: 'para', text: t('ha.agreements.recurringText') },
    { t: 'tip', kind: 'warn', title: t('ha.agreements.email'), text: t('ha.agreements.emailText') },
    { t: 'heading', text: t('ha.agreements.lists') },
    { t: 'para', text: t('ha.agreements.listsText') }]
  },
  dailySettlement: { id: 'dailySettlement', title: t('ha.dailySettlement.title'), category: t('ha.cat.sales'), read: t('ha.read2'), route: 'dagsoppgjor',
    keywords: t('ha.dailySettlement.keywords'),
    lead: t('ha.dailySettlement.lead'),
    blocks: [
    { t: 'step', n: 1, title: t('ha.dailySettlement.connect'), text: t('ha.dailySettlement.connectText') },
    { t: 'step', n: 2, title: t('ha.dailySettlement.ready'), text: t('ha.dailySettlement.readyText') },
    { t: 'step', n: 3, title: t('ha.dailySettlement.review'), text: t('ha.dailySettlement.reviewText') },
    { t: 'tip', kind: 'info', title: t('ha.dailySettlement.manual'), text: t('ha.dailySettlement.manualText') }]
  },
  projects: { id: 'projects', title: t('ha.projects.title'), category: t('ha.cat.sales'), read: t('ha.read3'), route: 'prosjekter',
    keywords: t('ha.projects.keywords'),
    lead: t('ha.projects.lead'),
    blocks: [
    { t: 'step', n: 1, title: t('ha.projects.create'), text: t('ha.projects.createText') },
    { t: 'step', n: 2, title: t('ha.projects.activity'), text: t('ha.projects.activityText') },
    { t: 'step', n: 3, title: t('ha.projects.hours'), text: t('ha.projects.hoursText') },
    { t: 'step', n: 4, title: t('ha.projects.invoice'), text: t('ha.projects.invoiceText') },
    { t: 'tip', kind: 'tip', title: t('ha.projects.costs'), text: t('ha.projects.costsText') }]
  },
  inventory: { id: 'inventory', title: t('ha.inventory.title'), category: t('ha.cat.purchase'), read: t('ha.read3'), route: 'varelager',
    keywords: t('ha.inventory.keywords'),
    lead: t('ha.inventory.lead'),
    blocks: [
    { t: 'heading', text: t('ha.inventory.auto') },
    { t: 'para', text: t('ha.inventory.autoText') },
    { t: 'step', n: 1, title: t('ha.inventory.start'), text: t('ha.inventory.startText') },
    { t: 'step', n: 2, title: t('ha.inventory.count'), text: t('ha.inventory.countText') },
    { t: 'step', n: 3, title: t('ha.inventory.finish'), text: t('ha.inventory.finishText') },
    { t: 'tip', kind: 'warn', title: t('ha.inventory.posting'), text: t('ha.inventory.postingText') }]
  }
})]);
